import * as React from 'react';
import { cn } from '@/utils/utils';

interface ScrimProps extends React.HTMLAttributes<HTMLDivElement> {
  /** dialog: under dialogs' content (a modal's backdrop); top: on the blocker layer, under only tours and toasts (the connection blocker). */
  layer?: 'dialog' | 'top';
  /** strong: a heavier dim for a hard stop. */
  strength?: 'normal' | 'strong';
  /** Hidden, it still catches clicks but draws nothing (the moment before a blocker shows). */
  visible?: boolean;
}

/** Dims the page behind something that needs the user's attention, and catches clicks on it. Its children sit centred. */
export const Scrim = React.forwardRef<HTMLDivElement, ScrimProps>(({ layer = 'dialog', strength = 'normal', visible = true, className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'pointer-events-auto fixed inset-0 flex items-center justify-center transition-colors duration-lureo-duration-slow',
      layer === 'dialog' ? 'z-lureo-layer-overlay' : 'z-lureo-layer-blocker',
      visible ? cn(strength === 'strong' ? 'bg-lureo-shade/55' : 'bg-lureo-shade/40', 'backdrop-blur-lureo-blur-sm') : 'bg-transparent',
      className,
    )}
    {...props}
  />
));
Scrim.displayName = 'Scrim';
